import type { SVGProps } from 'react';

export const AmazonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#002E64"
      fillRule="evenodd"
      d="M22.435 3H1.565C.701 3 0 3.7 0 4.565v14.609c0 .864.7 1.565 1.565 1.565h20.87c.864 0 1.565-.7 1.565-1.565V4.565C24 3.701 23.3 3 22.435 3Z"
      clipRule="evenodd"
    />
    <path
      fill="#FE9B00"
      fillRule="evenodd"
      d="M14.262 13.687c-1.092.806-2.674 1.234-4.036 1.234a7.303 7.303 0 0 1-4.93-1.88c-.102-.093-.01-.219.112-.147 1.404.817 3.14 1.309 4.933 1.309 1.21 0 2.54-.251 3.763-.77.184-.079.338.121.158.254Z"
      clipRule="evenodd"
    />
    <path
      fill="#FE9B00"
      fillRule="evenodd"
      d="M14.716 13.17c-.14-.18-.923-.085-1.275-.044-.107.013-.123-.08-.027-.147.624-.439 1.648-.312 1.767-.166.12.149-.031 1.175-.617 1.665-.09.075-.176.035-.135-.064.132-.33.426-1.066.287-1.245Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M13.466 9.88v-.427c0-.065.05-.108.108-.108h1.91c.062 0 .11.044.11.107v.366c0 .062-.051.141-.143.268l-.99 1.414c.367-.01.756.046 1.09.234.075.042.096.104.102.166v.455c0 .062-.069.135-.141.097a2.202 2.202 0 0 0-2.02.004c-.066.036-.136-.036-.136-.099v-.432c0-.07.002-.187.071-.293l1.147-1.645h-.998a.107.107 0 0 1-.11-.108ZM6.496 12.542h-.582a.11.11 0 0 1-.103-.098V9.46c0-.06.05-.107.112-.107h.542a.11.11 0 0 1 .106.1v.39h.01c.142-.377.408-.553.766-.553.363 0 .591.176.754.553a.825.825 0 0 1 .803-.553c.244 0 .51.1.673.327.185.25.147.615.147.935v1.883a.11.11 0 0 1-.113.108h-.58a.109.109 0 0 1-.105-.107v-1.582c0-.126.01-.44-.016-.559-.044-.2-.174-.257-.342-.257a.387.387 0 0 0-.348.244c-.059.151-.054.402-.054.572v1.581a.11.11 0 0 1-.112.108h-.58a.109.109 0 0 1-.105-.107v-1.582c0-.333.054-.822-.358-.822-.418 0-.402.477-.402.822v1.581a.112.112 0 0 1-.113.107Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M17.24 9.29c-.841 0-1.308.722-1.308 1.65 0 .924.46 1.665 1.308 1.665.814 0 1.329-.722 1.329-1.633 0-.942-.467-1.682-1.33-1.682Zm0 2.7c-.456 0-.45-.779-.45-1.143s.027-.948.455-.948c.185 0 .315.081.38.289.076.238.087.54.087.79 0 .383-.022 1.012-.472 1.012Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M19.688 12.542h-.58a.11.11 0 0 1-.104-.107l-.001-2.985a.11.11 0 0 1 .112-.097h.54a.11.11 0 0 1 .102.083v.457h.011c.163-.408.391-.603.792-.603.26 0 .516.095.679.352.152.238.152.64.152.928v1.878a.11.11 0 0 1-.112.094h-.582a.11.11 0 0 1-.104-.094v-1.62c0-.327.038-.804-.363-.804-.142 0-.272.095-.337.239-.081.182-.092.364-.092.565v1.606a.111.111 0 0 1-.113.108Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M12.978 11.995c-.106-.146-.22-.266-.22-.539v-.905c0-.384.028-.737-.255-1.001-.223-.213-.593-.29-.876-.29-.553 0-1.17.207-1.3.891-.014.072.04.11.087.122l.563.06c.053-.002.09-.054.101-.106.049-.236.246-.35.468-.35.12 0 .256.044.326.151.081.12.07.284.07.422v.076c-.337.037-.778.063-1.093.201a.988.988 0 0 0-.62.95c0 .604.381.906.87.906.414 0 .64-.097.96-.422.105.153.14.227.333.387a.12.12 0 0 0 .137-.014l.001.002c.117-.104.328-.287.446-.386.047-.039.04-.102.002-.155Zm-1.035-.878c0 .227.005.415-.109.617-.092.164-.24.264-.402.264-.223 0-.353-.17-.353-.421 0-.495.444-.585.864-.585v.125ZM5.356 11.995c-.106-.146-.22-.266-.22-.539v-.905c0-.384.028-.737-.255-1.001-.223-.213-.592-.29-.875-.29-.553 0-1.17.207-1.3.891-.014.072.04.11.087.122l.563.06c.053-.002.09-.054.101-.106.049-.236.246-.35.468-.35.12 0 .255.044.326.151.081.12.07.284.07.422v.076c-.337.037-.777.063-1.093.201a.988.988 0 0 0-.62.95c0 .604.381.906.87.906.414 0 .64-.097.96-.422.104.153.14.227.332.387a.12.12 0 0 0 .138-.014l.001.002c.116-.104.327-.287.446-.386.047-.039.038-.102.001-.155Zm-1.035-.878c0 .227.005.415-.108.617-.093.164-.24.264-.403.264-.222 0-.353-.17-.353-.421 0-.495.444-.585.865-.585v.125Z"
    />
  </svg>
);
